<template>
    <div class="DshEditPanel">
        <Form class="DshEditPanel-form" :model="value" :label-width="80" label-position="left">
            <FormItem label="应用名称">
                <Input v-model="value.name" placeholder="请输入应用名称" autofocus @on-blur="onBlur(value)" />
            </FormItem>

            <FormItem label="主题颜色">
                <div class="DshEditPanel-colors">
                    <div
                        v-for="(colorItem, colorKey) in $appData.themeColors"
                        :key="colorKey"
                        class="DshEditPanel-colors-item"
                        @click="$dispatchEvent(operationMap.updateColor, colorItem.color, colorKey, value)"
                    >
                        <div class="DshEditPanel-colors-item-content" :style="{ backgroundColor: colorItem.color }"></div>
                        <Icon
                            v-if="colorItem.color === value.color"
                            class="DshEditPanel-colors-item-icon"
                            type="ios-checkmark-circle"
                            size="16"
                        />
                    </div>
                </div>
            </FormItem>

            <FormItem label="主题图标">
                <div class="DshEditPanel-icons">
                    <div
                        v-for="(iconItem, iconIndex) in $appData.icons"
                        :key="iconIndex"
                        class="DshEditPanel-icons-item"
                        :style="{
                            backgroundColor: $appData.themeColors[value.color].bgColor,
                            border: value.icon === iconItem ? `1px solid ${value.color}` : 'none'
                        }"
                        @click="$dispatchEvent(operationMap.updateIcon, iconItem, iconIndex, value)"
                    >
                        <div class="DshEditPanel-icons-item-content" :style="{backgroundImage: 'url('+ $appData.themeColors[value.color].bgUrl +')'}">
                            <Icon :custom="'bico-font ' + iconItem"></Icon>
                        </div>
                    </div>
                </div>
            </FormItem>
        </Form>

        <!-- 操作按钮 -->
        <dsh-buttons
            class="bri-footer"
            :list="$getOperationList(['cancel', 'confirm'])"
            @click="$dispatchEvent($event)"
        ></dsh-buttons>
    </div>
</template>

<script>
    export default {
        components: {},
        name: "DshEditPanel",
        props: {
            value: {
                type: Object,
                default () {
                    return {};
                }
            }
        },
        data () {
            return {
                operationMap: {
                    updateColor: {
                        name: "修改主题色",
                        type: "updateColor",
                        event: "clickUpdateColor"
                    },
                    updateIcon: {
                        name: "修改图标",
                        type: "updateIcon",
                        event: "clickUpdateIcon"
                    },
                    cancel: {
                        name: "取消",
                        type: "cancel",
                        event: "clickCancel"
                    },
                    confirm: {
                        name: "确定",
                        type: "confirm",
                        btnType: "primary",
                        event: "clickConfirm"
                    }
                }
            };
        },
        computed: {},
        created () {
            this.init();
        },
        methods: {
            // 初始化
            init () {
                Object.assign(this.value, {
                    oldName: this.value.name,
                    color: this.value.color || Object.values(this.$appData.themeColors)[0].color,
                    icon: this.value.icon || this.$appData.icons[0]
                });
            },

            onBlur (value) {
                value.name || (value.name = value.oldName || "未命名");
            },
            // 点击修改应用主题色
            clickUpdateColor (item, colorItem, colorKey, appObj) {
                appObj.color = colorItem;
            },
            // 点击修改应用图标
            clickUpdateIcon (item, iconItem, iconIndex, appObj) {
                appObj.icon = iconItem;
            },
            // 点击取消
            clickConfirm () {
                this.$emit("on-ok", this.value);
            },
            // 点击取消
            clickCancel () {
                this.$emit("on-cancel");
            }
        }
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/other/DshEditPanel.vue